import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask w-full h-full"
}
const _hoisted_2 = {
  class: "modal-container-day-model",
  ref: "target"
}
const _hoisted_3 = { class: "modal-body mtop-10" }
const _hoisted_4 = { class: "row w-full" }
const _hoisted_5 = { class: "col-0-8 colend mright-04" }
const _hoisted_6 = { class: "col-1-5 w-full flex gap-2" }
const _hoisted_7 = { class: "row w-full mtop-10" }
const _hoisted_8 = { class: "col-0-8 colend mright-04" }
const _hoisted_9 = { class: "col-1-5 w-full flex gap-2" }
const _hoisted_10 = { class: "row w-full mtop-10" }
const _hoisted_11 = { class: "col-0-8 colend mright-04" }
const _hoisted_12 = { class: "col-1-5 w-full" }

import {computed, Ref, ref, watch} from "vue";
import {DayModelLightResponse, PersonLightResponse, SettingsApi, SpecialDayRequest, SpecialDayResponse} from "@/apiGenerate/medserver";
import {medServerApiConfig} from "@/config/medserver-api.config";
import {format} from "date-fns";
import {useI18n} from "vue-i18n";
import { ApiError, DateFormat, ItemSelect } from "@/models/share.model";
import { useToast } from 'primevue';
import { toastError, toastSuccess, toastWarn } from '@/utils/toast-utils';
import Checkbox from 'primevue/checkbox';
import { useAppUserStore } from "@/stores/appUser";


export default /*@__PURE__*/_defineComponent({
  __name: 'esSpecialDaysInputForm',
  props: {
    selectedInstituteId: {},
    dayModels: {},
    isOpen: { type: Boolean },
    header: {},
    selectedHealthPro: {}
  },
  emits: ["add-modal-close"],
  setup(__props: any, { emit: __emit }) {


const props = __props;

const {t} = useI18n();
const toast = useToast();
const appUserStore = useAppUserStore();

const settingsApi = new SettingsApi(medServerApiConfig);
const isRange = ref<boolean>(false);
const rangeDate = ref({
  start: Date.now(),
  end: undefined,
});

const emit = __emit;

const currentPersonId = computed(() => {
  if (!appUserStore.currentAppUserData || !appUserStore.currentAppUserData.healthGroupMemberships) {return null}
  return appUserStore.currentAppUserData.healthGroupMemberships[0].pwr.personWithRoleId
});

const startDate = computed(() => rangeDate.value?.start ? format(rangeDate.value.start, DateFormat.ISO_SMALL) : '')
const endDate = computed(() => rangeDate.value?.end ? format(rangeDate.value.end, DateFormat.ISO_SMALL) : startDate.value)

const createNewSpecialDays = async () => {
  if (!rangeDate.value.start) return;
  if (!dayModel.value) return;

  if(!isRange.value && (startDate.value !== endDate.value) ){
    rangeDate.value.end = rangeDate.value?.start
  }

  const specialDayRequest: SpecialDayRequest = {
    dayModelId: dayModel.value.id,
    periodStart: startDate.value,
    periodEnd: endDate.value,
  };

  await settingsApi.createSpecialDayForInstitute({
    instituteId: props.selectedInstituteId,
    specialDayRequest: specialDayRequest,
    doctorId: props.selectedHealthPro?.id ? props.selectedHealthPro.id : currentPersonId.value
  }).then((specialDayResponse: SpecialDayResponse) => {
    if(specialDayResponse.warningCode) {
      toastWarn(toast, {
        summary: t('common.toast.success.add'),
        detail:  t(`warn.${specialDayResponse.warningCode}`)
      });
     } else {
      toastSuccess(toast, {
        summary: t('common.toast.success.add'),
        detail:  t('settings.label.specialDays.toast.created')
    });
     }
    emit('add-modal-close', true);
  }).catch((error: ApiError) => {
    toastError(toast, {
        summary: t('common.toast.error'),
        detail: t(`error.${error.status}`)
    });
    // Throw error to set at false the var __alreadyClicked in v-one-click directive
    throw error;
  });
}

const closeFormModal = () => {
  emit('add-modal-close', false);

}

const updateDate = (newDate: [number, number]) => {
  if (Array.isArray(newDate)) {
    rangeDate.value.start = newDate[0];
    rangeDate.value.end = newDate[1];
  } else {
    rangeDate.value.start = newDate;
    rangeDate.value.end = undefined;
  }
}

const dayModelResponseToItemSelect = (dayModel: DayModelLightResponse) => {
  if (dayModel) {
    return {
        id: dayModel.dayModelId,
        label: dayModel.name
      }
  }  
}

const dayModel: Ref<ItemSelect> = ref(dayModelResponseToItemSelect(props.dayModels[0]));

const getFormattedDayModels = () => {
  if (props.dayModels) {
    return props.dayModels.map(dayModel => dayModelResponseToItemSelect(dayModel));
  }

  return []; 
}

const updateDayModel = (newDayModel: ItemSelect) => {
  dayModel.value = newDayModel;
}


watch(
    () => props.isOpen,
  () => {
    rangeDate.value = {
      start: Date.now(),
      end: undefined,
    };
    if (props.dayModels) {
      dayModel.value = dayModelResponseToItemSelect(props.dayModels[0]);
    }
  }
);


return (_ctx: any,_cache: any) => {
  const _component_es_modal_header = _resolveComponent("es-modal-header")!
  const _component_text_item = _resolveComponent("text-item")!
  const _component_esInputDateTime = _resolveComponent("esInputDateTime")!
  const _component_esSelect = _resolveComponent("esSelect")!
  const _component_es_modal_footer = _resolveComponent("es-modal-footer")!

  return (_ctx.isOpen)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_es_modal_header, {
            header: _unref(t)(_ctx.header)
          }, null, 8, ["header"]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_text_item, {
                  txt: _unref(t)('settings.label.specialDays.modal.period'),
                  styles: "main-m"
                }, null, 8, ["txt"])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_unref(Checkbox), {
                  modelValue: isRange.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isRange).value = $event)),
                  binary: ""
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_text_item, {
                  txt: _unref(t)('settings.label.specialDays.modal.date'),
                  styles: "main-m"
                }, null, 8, ["txt"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_esInputDateTime, {
                  dateTimeValue: new Date(startDate.value),
                  dateFormat: _unref(DateFormat).DATEPICKER,
                  withTime: false,
                  range: isRange.value,
                  onUpdateDateTime: _cache[1] || (_cache[1] = ($event: any) => (updateDate($event))),
                  size: "small",
                  placeholder: _unref(t)('settings.label.specialDays.modal.range')
                }, null, 8, ["dateTimeValue", "dateFormat", "range", "placeholder"])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_text_item, {
                  txt: _unref(t)('settings.label.specialDays.modal.dayModel'),
                  styles: "main-m"
                }, null, 8, ["txt"])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_esSelect, {
                  options: getFormattedDayModels(),
                  selectedData: dayModel.value,
                  onChangeSelect: _cache[2] || (_cache[2] = ($event: any) => (updateDayModel($event)))
                }, null, 8, ["options", "selectedData"])
              ])
            ])
          ]),
          _createVNode(_component_es_modal_footer, {
            onModalCancel: closeFormModal,
            confirmModalMethod: () => createNewSpecialDays()
          }, null, 8, ["confirmModalMethod"])
        ], 512)
      ]))
    : _createCommentVNode("", true)
}
}

})